import React from "react";
import { Box, Grid, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import { GradientTypo } from "../header/Header";

import { ReactComponent as DevelopAlliancesIcon } from "../../resources/images/svg/home/developAlliances.svg";
import diagram from "../../resources/images/png/home/alliances/diagram.png";
import { useIsMobile } from "../../hooks/responsive";
import DetailCard from "./alliances/DetailCard";
import SpecialCard from "../card/SpecialCard";
import PriceFormater from "../PriceFormater";
import RainbowDivider from "../misc/RainbowDivider";
import {useGetEventsQuery} from "../../store/api/events";
import EventPublicCard from "./alliances/EventPublicCard";
import moment from "moment";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: "white",
    position: "relative",
  };
});

const DevelopAlliances = () => {
  const isMobile = useIsMobile();
  const theme = useTheme();

  const { data: eventsData1 } = useGetEventsQuery({ activites: 2, authToken: null, offset: 0, limit: 1 });

  const event1 = React.useMemo(() => {
    return eventsData1?.items[0] || null;
  }, [eventsData1])

  const dateTexte1 = React.useMemo(() => {
      return `le ${moment.unix(event1?.dateDebut).format("LL")}`;
      return null;
    }, [event1]);

  const { data: eventsData2 } = useGetEventsQuery({ activites: 3, authToken: null, offset: 0, limit: 1 });

  const event2 = React.useMemo(() => {
    return eventsData2?.items[0] || null;;
  }, [eventsData2])

  const dateTexte2 = React.useMemo(() => {
      return `le ${moment.unix(event2?.dateDebut).format("LL")}`;
      return null;
    }, [event2]);

  return (
    <Container className={"develop-alliances"}>
      <CenteredSiteBlock
        sx={{
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "top",
          marginTop: theme.spacing(isMobile ? 5 : 10),
          marginBottom: theme.spacing(isMobile ? 5 : 10),
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            marginRight: "5vw",
            marginLeft: "5vw",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  flexWrap: "nowrap",
                  alignItems: "center",
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-start",
                  },
                  width: "100%",
                }}
              >
                <DevelopAlliancesIcon
                  width={"62px"}
                  height={"62px"}
                  style={{
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                />
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 500,
                    margin: 0,
                    width: { xs: "100%", sm: "100%", md: "auto" },
                    textAlign: "center",
                    fontSize: isMobile ? "30px" : "35px",
                  }}
                >
                  Grandissez dans votre pratique
                </Typography>
              </Box>
              <GradientTypo
                variant={"h2"}
                background={theme.palette.linearPro}
                sx={{
                  fontFamily: "YesevaOne",
                  textTransform: "lowercase",
                  textAlign: { xs: "center", lg: "left" },
                  margin: 0,
                  fontSize: isMobile ? "30px" : "35px",
                  width: "100%",
                  fontWeight: 500,
                  "&:first-letter": {
                    textTransform: "lowercase !important",
                  },
                }}
              >
                &nbsp;{`avec nos événements`}
              </GradientTypo>
              <Typography
                sx={{
                  marginTop: 3,
                  marginBottom: 3,
                  maxWidth: 1350 / 2,
                  marginLeft: isMobile ? undefined : "10px",
                }}
              >
                Accédez à nos événements privés pour nourrir votre pratique et créer 
                de nouvelles synergies interdisciplinaires, quel que soit votre parcours.<br/>
                Approfondissez vos spécialités, découvrez de nouveaux outils, affinez 
                votre posture et enrichissez votre approche au contact d’experts et de 
                praticiens partageant les mêmes valeurs.<br/>
                Parfois, il suffit surtout d’un cadre inspirant et de belles rencontres… pour 
                continuer à évoluer et trouver pleinement sa place.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", lg: "50%" },
            }}
          >
            <img
              src={diagram}
              alt={"diagram"}
              style={{
                // width: "100%",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
        <Grid
          container
          mt={5}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: "5vw",
            marginRight: "5vw",
          }}
        >
          <Grid
            item
            xs={12}
            sm={4}
            mb={2}
            sx={{
              width: { xs: "100%", md: "45%", lg: "30%" },
            }}
          >
            <DetailCard
              preTitle={
                <Box sx={{ width: "140px", mb: 2 }}>
                  <SpecialCard
                    sx={{
                      backgroundColor: "#F3F2F5",
                      display: "flex",
                      justifyContent: "center",
                      padding: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        margin: 0,
                        padding: 0,
                        maxWidth: "150px",
                      }}
                    >
                      {"En ligne"}
                    </Typography>
                  </SpecialCard>
                </Box>
              }
              title={
                <Typography
                  sx={{
                    marginTop: 3,
                    fontWeight: 700,
                    margin: 0,
                    width: isMobile ? "100%" : undefined,
                    fontSize: "28px",
                    lineHeight: "1.2em",
                    fontFamily: "Branding Bold",
                    height: !isMobile ? "90px" : undefined,
                  }}
                >
                  {`Cercles `}
                  <span
                    style={{
                      color: "#1D73FF",
                    }}
                  >
                    d'échanges entre praticiens
                  </span>
                </Typography>
              }
              content={
                <>
                  <Typography
                    sx={{
                      mt: 2,
                      height: !isMobile ? "190px" : undefined,
                    }}
                  ><span style={{fontFamily: "Branding Bold",}}>Une fois par mois - </span>{`Ces cercles confidentiels et bienveillants rassemblent 10 professionnels autour de perspectives communes.`}
                  <br/>{`On y explore librement les enjeux visibles et invisibles des pratiques sous les angles éthiques, théoriques ou personnels dans un espace rare de partage, d’intelligence collective et d’évolution.`}</Typography>
                </>
              }
              footer={
                <><PriceFormater
                  price={2900}
                  withTitle={false}
                  priceProps={{
                    style: {
                      fontWeight: 900,
                      fontFamily: "Branding Bold",
                      fontSize: "38px",
                    },
                  }}
                  period={" cercle"}
                  subTitle={
                    <Typography
                      sx={{
                        color: "#0D0034bb",
                        lineHeight: "1.2em",
                        fontSize: "14px",
                      }}
                    >
                      Réservé aux abonnés Inexploré Praticiens
                    </Typography>
                  }
                />

                  <Grid container mt={2} mb={3} spacing={5}>
                    {event1 && (
                        <Grid
                          size={{
                            xs: 12,
                            sm: 12,
                            md: 12,
                          }}
                          sx={{
                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 900,
                              fontFamily: "Branding Bold",
                            }}
                          >
                            Prochain cercle: {dateTexte1}
                          </Typography>
                          <EventPublicCard event={event1} />
                        </Grid>
                    )}
                  </Grid>

                </>
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              width: { xs: "100%", md: "45%", lg: "30%" },
            }}
          >
            <DetailCard
              preTitle={
                <Box sx={{ width: "140px", mb: 2 }}>
                  <SpecialCard
                    sx={{
                      backgroundColor: "#F3F2F5",
                      display: "flex",
                      justifyContent: "center",
                      padding: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        margin: 0,
                        padding: 0,
                        maxWidth: "150px",
                      }}
                    >
                      {"En ligne"}
                    </Typography>
                  </SpecialCard>
                </Box>
              }
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      margin: 0,
                      width: isMobile ? "100%" : undefined,
                      fontSize: "28px",
                      lineHeight: "1.2em",
                      fontFamily: "Branding Bold",
                      height: !isMobile ? "90px" : undefined,
                    }}
                  >
                    {`Ateliers `}
                    <span
                      style={{
                        color: "#1D73FF",
                      }}
                    >
                       thématiques autour d'un expert
                    </span>
                  </Typography>
                </>
              }
              content={
                <>
                  <Typography
                    sx={{
                      mt: 2,
                      height: !isMobile ? "190px" : undefined,
                    }}
                  ><span style={{fontFamily: "Branding Bold",}}>Une fois par mois - </span>{`Approfondissez votre pratique et vos connaissances et affinez votre posture professionnelle 
                  aux côtés d'un expert de renommée ! Dans ces ateliers en cercle restreint, vous bénéficiez 
                  d'une transmission unique et pratique sur une thématique particulière. 
                  Recevez des conseils personnalisés adaptés aux défis que vous rencontrez.`}</Typography>
                </>
              }
              footer={
                <>
                  <PriceFormater
                    price={4900}
                    withTitle={false}
                    priceProps={{
                      style: {
                        fontWeight: 900,
                        fontFamily: "Branding Bold",
                        fontSize: "38px",
                      },
                    }}
                    period={" atelier"}
                    subTitle={
                      <Typography
                        sx={{
                          color: "#0D0034bb",
                          lineHeight: "1.2em",
                          fontSize: "14px",
                        }}
                      >
                        Réservé aux abonnés Inexploré Praticiens
                      </Typography>
                    }
                  />

                  <Grid container mt={2} mb={isMobile ? 5:3} spacing={5}>
                    {event2 && (
                        <Grid
                          size={{
                            xs: 12,
                            sm: 12,
                            md: 12,
                          }}
                          sx={{
                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 900,
                              fontFamily: "Branding Bold",
                            }}
                          >
                            Prochain atelier: {dateTexte2}
                          </Typography>
                          <EventPublicCard event={event2} />
                        </Grid>
                    )}
                  </Grid>

                </>
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            mb={2}
            sx={{
              width: { xs: "100%", md: "45%", lg: "30%" },
            }}
          >
            <DetailCard
              preTitle={
                <Box sx={{ width: "160px", mb: 2 }}>
                  <SpecialCard
                    sx={{
                      backgroundColor: "#F3F2F5",
                      display: "flex",
                      justifyContent: "center",
                      padding: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      {"En présentiel"}
                    </Typography>
                  </SpecialCard>
                </Box>
              }
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      margin: 0,
                      width: isMobile ? "100%" : undefined,
                      fontSize: "28px",
                      lineHeight: "1.2em",
                      fontFamily: "Branding Bold",
                      height: !isMobile ? "90px" : undefined,
                    }}
                  >
                    {`Soirées `}
                    <span
                      style={{
                        color: "#1D73FF",
                      }}
                    >
                      de connexion sur Paris, Bruxelles, Lyon, Toulouse et
                      Nantes
                    </span>
                  </Typography>
                </>
              }
              content={
                <Typography
                  sx={{
                    mt: 2,
                    height: !isMobile ? "190px" : undefined,
                  }}
                >{`Chaque trimestre, Inexploré Praticiens vous propose des rencontres entre professionnels pour penser ensemble, expérimenter des formats collaboratifs et créer de nouvelles synergies. Au menu : tables rondes, co-développement sensitif, mini-conférences percutantes ou speed dating thématiques. Des moments vivants, participatifs et inspirants…`}</Typography>
              }
              footer={
                <PriceFormater
                  price={5000}
                  withTitle={false}
                  priceProps={{
                    style: {
                      fontWeight: 900,
                      fontFamily: "Branding Bold",
                      fontSize: "38px",
                    },
                  }}
                  period={" soirée"}
                  subTitle={
                    <Typography
                      sx={{
                        color: "#0D0034bb",
                        lineHeight: "1.2em",
                        fontSize: "14px",
                      }}
                    >
                      Réservé aux abonnés Inexploré Praticiens
                    </Typography>
                  }
                />
              }
            />
          </Grid>
        </Grid>
      </CenteredSiteBlock>
      <RainbowDivider />
    </Container>
  );
};

export default DevelopAlliances;
